export default __webpack_public_path__ + "static/media/earth.6bb4ee44.svg";